module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports"
  }, [(_vm.$store.state.match) ? _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Synsrapporter\n                ")]), _vm._v(" "), (_vm.$store.state.showingResult && !_vm.$store.state.loadingInspection && _vm.$store.state.carData.inspection !== null) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.inspection.Rapporter.length > 0) ? _c('div', {
    staticClass: "report-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sortedReports), function(report, index) {
    return _c('div', {
      staticClass: "single-report",
      class: {
        'active': _vm.activeReport === index, 'good': report.Synsresultat === 'Godkendt', 'neutral': report.Synsresultat !== 'Godkendt'
      },
      on: {
        "click": function($event) {
          _vm.activeReport = index
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(report.SynsdatoFormateret, 'DD. MMM. YYYY')) + "\n                            ")]), _vm._v(" "), (report.Synsresultat === 'Godkendt') ? _c('div', {
      staticClass: "result good"
    }, [_vm._v("\n                                Godkendt\n                            ")]) : (report.Synsresultat === 'Middel') ? _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Middel\n                            ")]) : (report.Synsresultat === 'Betinget godkendt') ? _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Betinget godkendt\n                            ")]) : _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                Kan godk. efter omsyn\n                            ")])])
  })], 2) : _c('div', [_vm._v("\n                        Køretøjet har endnu ikke været synet.\n                    ")])]) : _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ingen synsdata\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column column__large"
  }, [_vm._l((_vm.sortedReports), function(report, index) {
    return (_vm.activeReport !== null && _vm.activeReport === index && _vm.$store.state.carData.inspection) ? _c('div', {
      staticClass: "block animated fadeIn"
    }, [_c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "active-report"
    }, [_c('div', {
      staticClass: "header"
    }, [(report.Synsresultat === 'Godkendt') ? _c('div', {
      staticClass: "result good"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                            ")]) : _c('div', {
      staticClass: "result neutral"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('b', [_vm._v(_vm._s(report.Firma))]), _vm._v(" "), _c('br'), _vm._v("\n                                " + _vm._s(report.Adresse) + "\n                                "), _c('br'), _vm._v("\n                                CVR: " + _vm._s(report.Cvr) + "        \n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "boxes"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Synsdato\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(report.SynsdatoFormateret, 'D. MMMM YYYY')) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Synstype\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(report.Synstype) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Nummerplade\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(report.RegNr) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                    Kilometerstand\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("thousand")(report.Kmstand)) + " km\n                                ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (report.Fejl) ? _c('div', {
      staticClass: "error-wrapper"
    }, [_c('div', {
      staticClass: "error__title"
    }, [_vm._v("\n                                Fejl (" + _vm._s(report.Fejl.length) + ")\n                            ")]), _vm._v(" "), (report.Fejl.length > 0) ? _c('div', {
      staticClass: "error-list"
    }, _vm._l((report.Fejl), function(error) {
      return _c('div', {
        staticClass: "error"
      }, [_c('b', [_vm._v(_vm._s(error.Number))]), _vm._v(" - " + _vm._s(error.Description) + "\n                                ")])
    }), 0) : _c('div', [_vm._v("\n                                Ingen fejl registreret.\n                            ")])]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.activeReport === null) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Vælg en synsrapport i menuen for at se hele rapportens detaljer her.\n                ")])]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-helper"
  }, [_vm._v("\n                            Vælg en synsrapport og scroll ned for at læse detaljerne\n                            "), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdbf5a28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/reports.vue
// module id = 359
// module chunks = 1